import CommentBoxTransparent from './CommentBoxTransparent';

export default CommentBoxTransparent;
